<template>
  <div>
    <img src="@/assets/mystery.png" alt="Unknown purifier">
    <p>The mystery purifier you're after doesn't seem to exist!</p>
    <p>Try adjusting your search options above to find another option. Here are some pages for further reading:
    </p>
    <router-link to="/sensitive-to-noise">I'm really sensitive to noise</router-link>
    <router-link to="/low-cost-purifiers">I'm on a really tight budget</router-link>
</div>
</template>

<script>
import {all} from '@/data/purifiers.js'
import PurifierImage from '@/components/PurifierImage'

export default {
  name: 'Noise',
  components: {PurifierImage},
  props: ['id'],
  computed: {
    purifier: function () {
      console.log(this.id)
      var a = all.filter((i) => {
        return i.id === this.id
      })[0]
      console.log(a)
      return a
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
a h1, a h2, a:hover {
  text-decoration:none;
  color: #2c3e50;
}
img.purifier_img {
  max-width:200px;
}
.backbutton {
  text-align:left;
}
.purifierinfo {
  max-width:400px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/NoChoicesView.vue